module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/df28596aead9efac5480b1f106abdba3.gif";